import {
    getModule,
    Module,
    Mutation,
    VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';

@Module({
    namespaced: true,
    name: 'language',
    store,
    dynamic: true,
})
class LanguageModule extends VuexModule {
    language: string = 'sv';

    @Mutation
    setLanguage(language: string) {
        this.language = language;
    }

}

export default getModule(LanguageModule);
